export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyCDoa7A5QnCFkfZFPRJW_WEGJ73UHQ3wLU',
    authDomain: 'work-time-recorder.firebaseapp.com',
    databaseURL: 'https://work-time-recorder.firebaseio.com',
    projectId: 'work-time-recorder',
    messagingSenderId: '25748572313',
    appId: "1:25748572313:web:81b46d858383f26a901008",
    measurementId: "G-LQ9NX9LZJK"
  },
  setting: {
    functionUri: 'https://us-central1-work-time-recorder.cloudfunctions.net',
    ObcUri: 'https://hermes.japaneast.cloudapp.azure.com:443/stamps',
    ObcToken: '~0LP|GtF8,Q_w_t8'
  }
};
